module.exports = __webpack_public_path__ + "media/application/images/ui/icon-address-d7288d7e6ad29056d39041376065ce02.png";